import type { Products } from "../types"

export const products: Products = new Map([
  [
    "re7-labs-bob",
    {
      name: "Re7 Labs Cluster",
      entity: "re7-labs",
      vaults: [
        "0xB615D3123410EE89542b027DC71e87b4Fc05EA80",
        "0x33Cc3800574c4bEe6D7428e707Db82d1543d639D",
        "0x11DA346d3Fdb62641BDbfebfd54b81CAA871aEf6",
      ],
    },
  ],
])
